import { ChevronRight, CheckCircle2 } from 'lucide-react';
import { fmtDate } from '@/lib/utils';
import type { PrestHistoryItemData } from './types';

interface PrestHistoryItemProps {
  prest: PrestHistoryItemData;
  onOpen: (p: PrestHistoryItemData) => void;
}

/**
 * Card clicável de prestação concluída no histórico.
 * Touch target ≥ 44px via minHeight.
 */
export function PrestHistoryItem({ prest, onOpen }: PrestHistoryItemProps) {
  return (
    <button
      type="button"
      onClick={() => onOpen(prest)}
      aria-label={`Ver detalhes da prestação ${prest.label}`}
      style={{
        textAlign: 'left',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px',
        background: 'var(--card)',
        border: '1px solid var(--card-stroke)',
        borderRadius: 'var(--r-3)',
        cursor: 'pointer',
        minHeight: 44,
      }}
    >
      <span
        style={{
          width: 38,
          height: 38,
          borderRadius: 11,
          background: 'var(--pass-soft)',
          color: 'var(--pass)',
          display: 'grid',
          placeItems: 'center',
          flexShrink: 0,
        }}
      >
        <CheckCircle2 size={18} strokeWidth={1.8} aria-hidden />
      </span>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--fg)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {prest.label}
        </div>
        <div
          style={{
            fontSize: 10.5,
            color: 'var(--fg-muted)',
            fontFamily: 'var(--font-mono)',
            marginTop: 2,
          }}
        >
          {prest.concluidaEm ? `Enviada ${fmtDate(prest.concluidaEm)}` : 'Concluída'}
        </div>
      </div>

      <ChevronRight size={16} style={{ color: 'var(--fg-dim)', flexShrink: 0 }} aria-hidden />
    </button>
  );
}
